import React, { Component } from 'react';
import _ from 'lodash';

import SimpleModal from '../SimpleModal';
import NoticeStore from '../../stores/NoticeStore';

export default class NewNoticePage extends Component {
  constructor(){
    super();

    this.state = {
      notice: {
        title: '',
        url: ''
      }
    }

    this.handleSave = this.handleSave.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(){
    this.setState({
      notice: {
        title: this.refs.title.value,
        url: this.refs.url.value
      }
    })
  }

  handleSave(event){
    event.preventDefault();

    NoticeStore.save(null, {
      notice: {
        title: this.state.notice.title,
        url: this.state.notice.url
      }
    }).then(()=>{
      this.props.handleCloseAndReloadData();
    })
  }

  render(){
    return (
      <div>
        <SimpleModal 
          isOpen={true}
          title={'แก้ไข'}
          showSubmitButton={false}
          onClose={()=>this.props.onClose()}>
          
          <form onSubmit={this.handleSave}>
            <div className='row form-group'>
              <div className='col-2 text-right'>
                <label className='required'>เรื่อง:</label>
              </div>
              <div className='col-10'>
                <input 
                  type='text' 
                  ref='title'
                  value={this.state.notice.title || ''}
                  className='form-control form-control-sm'
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-2 text-right'>
                <label className='required'>URL:</label>
              </div>
              <div className='col-10'>
                <input 
                  type='text' 
                  ref='url'
                  value={this.state.notice.url || ''}
                  className='form-control form-control-sm'
                  onChange={this.onChange} />
              </div>
            </div>
            <div className="modal-footer row">
              <button type='submit' className="btn btn-primary pointer">บันทึก</button>
              <button type='button' className="btn btn-secondary pointer" onClick={()=>this.props.onClose()}>Close</button>
            </div>

          </form>

        </SimpleModal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/NewNoticePage.js